export const breadcrumb = {
  title: 'Автоинформатор',

  campaign: {
    index: 'Кампании',
    edit: 'Редактировать кампанию',
    new: 'Добавить кампанию',
    tasks: 'Список задач кампании {name}'
  },
  tasks: { create: 'Создать задачу' }
};
